module.exports = __webpack_public_path__ + "static/img/org-certificate-new.e1dbe9fb.png";